import { Observable } from 'rxjs';

export abstract class ClutchStatusDataProvider {
  abstract payrollLocked$(payrollIdentifier: any): Observable<boolean>;
}
